module.exports = __webpack_public_path__ + "img/google-logo.1c997817.png";